// String.prototype.endsWith() polyfill
if (!String.prototype.endsWith) {
	String.prototype.endsWith = function (search, this_len) {
		if (this_len === undefined || this_len > this.length) {
			this_len = this.length;
		}
		return this.substring(this_len - search.length, this_len) === search;
	};
}

// Function to send GTM events
function sendGTMEvent(event) {
	window.dataLayer = window.dataLayer || [];

	window.dataLayer.push(event);
	if (window.location.host != "rooms.belgard.com" || document.body.classList.contains("logged-in")) {
		console.log(event);
	}
}

// Function to set iframe to load
function loadIframe(embed, src) {
	// Set src to start loading
	embed.classList.add("is-active");
	embed.setAttribute("src", src);

	sendGTMEvent({
		event: "_mv_loading",
		ar_event: "loading",
	});

	// Sends the load time to Google Analytics.
	if (window.performance) {
		// var iframeLoadStart = Math.round(performance.now());
		// embed.addEventListener("load", function (event) {
		// 	var iframeLoadEnd = Math.round(performance.now());
		// 	console.log("Load time: " + (iframeLoadEnd - iframeLoadStart));
		// 	function check_ga() {
		// 		if (typeof ga === "function") {
		// 			console.log("sending GA timing: " + (iframeLoadEnd - iframeLoadStart));
		// 			ga("send", "timing", "ar_embed", "load", iframeLoadEnd - iframeLoadStart, window.location.pathname);
		// 		} else {
		// 			setTimeout(check_ga, 500);
		// 		}
		// 	}
		// 	check_ga();
		// });
	}
}

document.addEventListener("DOMContentLoaded", function (event) {
	document.querySelectorAll(".slide-ar__embed").forEach(function (embed) {
		const image = embed.parentElement.querySelector(".slide-ar__image");

		const embed_src = embed.getAttribute("data-src");
		embed.removeAttribute("data-src");
		// console.log("retrieved embed src: " + embed_src);

		const loadingBar = embed.parentElement.querySelector(".slide-ar__loading-bar");
		const loadingIcon = embed.parentElement.querySelector(".slide-ar__loading-icon");

		// Ensure image/iframe loading happens sequentially
		// First, check if image is already loaded
		if (image.complete) {
			// If so, load embed
			loadIframe(embed, embed_src);
		} else {
			// Otherwise, set an event to load the embed once the image is loaded
			image.addEventListener("load", function (event) {
				loadIframe(embed, embed_src);
			});
		}

		// Handle messages from Meshmorph iframe
		function handleMessage(event) {
			//Reject events not fired by meshmorph iframe
			if (!event.origin.endsWith("meshmorph.com")) {
				return;
			}

			// Update progress bar
			if (event.data.eid == "_mv_loading_progress") {
				embed.classList.add("is-loading");

				var progress = event.data.value * 100 + "%";
				loadingBar.style.backgroundSize = progress;
			}

			// Add classes to embed when loaded
			if (event.data.eid == "_mv_loaded") {
				embed.classList.remove("is-loading");
				embed.classList.add("is-loaded");
			}

			if (event.data.eid == "_mv_model_visibility" && event.data.value == true) {
				embed.classList.add("is-visible");
			}

			// Send stuff to GTM
			if (event.data.eid !== "_mv_loading_progress") {
				var event_name = event.data.eid.split("_").join(" ").replace("mv", "").trim();

				sendGTMEvent({
					event: event.data.eid,
					ar_event: event_name,
					ar_event_data: event.data,
				});
			}
		}
		window.addEventListener("message", handleMessage, false);
	});
});
